import React, { useEffect, useState } from "react";
import Pagination from "@mui/material/Pagination";
import { useNavigate } from "react-router";
import SearchBar from "../../../../components/admin/usable/SearchBar";
import AddButton from "../../../../components/admin/usable/AddButton";
import TableLoader from "../../../../components/admin/usable/TableLoader";
import DeleteButton from "../../../../components/admin/usable/actions/DeleteButton";
import EditButton from "../../../../components/admin/usable/actions/EditButton";
import { deleteRoom, getRoomList, updateAll } from "../../../../api/admin/room";
import { Checkbox } from "@mui/joy";
import toast from "react-hot-toast";
import DuplicateButton from "../../../../components/admin/usable/actions/DuplicateButton";
import { useDispatch } from "react-redux";
import { setDuplicateRoom } from "../../../../redux/admin/dupHotelSlice";

const RoomList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [RoomData, setRoomData] = useState([]);
  const [FilteredData, setFilteredData] = useState([]);
  const [Search, setSearch] = useState("");
  const [Page, setPage] = useState(1);
  const [Limit, setLimit] = useState(10);
  const [PageData, setPageData] = useState("");
  const [CheckListData, setCheckListData] = useState([]);
  const [BulkDiscount, setBulkDiscount] = useState("");
  const [BulkTax, setBulkTax] = useState("");
  useEffect(() => {
    getRoomList(setRoomData, Page, Limit, setPageData);
  }, [Page, Limit]);

  useEffect(() => {
    if (Search.trim() === "") {
      setFilteredData(RoomData);
    } else {
      const result = RoomData.filter((item) =>
        item.hotelName.toLowerCase().includes(Search.toLowerCase()),
      );
      setFilteredData(result);
    }
  }, [Search, RoomData]);
  const handleDelete = (item) => {
    const id = item.roomId;
    deleteRoom(setRoomData, setPageData, Page, Limit, id);
  };

  const handleCheck = (roomId) => {
    setCheckListData((prev) =>
      prev.includes(roomId)
        ? prev.filter((id) => id !== roomId)
        : [...prev, roomId],
    );
  };
  const handleSelectAll = (checked) => {
    if (checked) {
      const allIds = FilteredData.map((item) => item.roomId);
      setCheckListData(allIds);
    } else {
      setCheckListData([]);
    }
  };
  const buildBulkPayload = () => {
    return CheckListData.map((roomId) => ({
      roomId,

      ...(BulkDiscount !== "" && {
        discount: Number(BulkDiscount),
      }),

      ...(BulkTax !== "" && {
        tax: Number(BulkTax),
      }),
    }));
  };
  const handleBulkUpdate = () => {
    const payload = buildBulkPayload();

    if (payload.length > 0) {
      updateAll(setRoomData, Page, Limit, setPageData, payload);
    } else {
      toast.error("Please check rooms first");
    }
  };
  const handleDup = (item) => {
    if (item) {
      dispatch(setDuplicateRoom(item));
      navigate("/admin/room/duplicate");
    }
  };
  return (
    <div className="space-y-5">
      <div className="flex justify-between items-center">
        <div className="flex justify-start items-center gap-2">
          <SearchBar
            onChange={(e) => setSearch(e.target.value)}
            text="Search Room by Hotel Name"
          />
          {CheckListData.length > 0 && (
            <div className="flex justify-start items-center gap-2">
              <input
                type="number"
                className="w-full py-2 focus:outline-none px-3 text-black/80"
                placeholder="Discount"
                value={BulkDiscount}
                onChange={(e) => setBulkDiscount(e.target.value)}
              />
              <input
                type="number"
                className="w-full py-2 focus:outline-none px-3 text-black/80"
                placeholder="Service Charge"
                value={BulkTax}
                onChange={(e) => setBulkTax(e.target.value)}
              />
              <AddButton onClick={handleBulkUpdate} text="Update Now" />
            </div>
          )}
        </div>
        <AddButton
          onClick={() => navigate("/admin/room/create")}
          text="Add Room"
        />
      </div>
      <div className="w-full overflow-x-auto">
        <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                <Checkbox
                  checked={
                    FilteredData.length > 0 &&
                    CheckListData.length === FilteredData.length
                  }
                  onChange={(e) => handleSelectAll(e.target.checked)}
                />
              </th>

              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                ID
              </th>

              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Hotel Logo
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Hotel Name
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Room Image
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Room Name
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Room Type
              </th>

              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Actual Price
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Discount
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Discounted Price
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                CreatedAt
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {FilteredData.length > 0 ? (
              <>
                {FilteredData.map((item, index) => {
                  return (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <Checkbox
                          checked={CheckListData.includes(item.roomId)}
                          onChange={() => handleCheck(item.roomId)}
                        />
                      </td>

                      <td className="px-4 py-3 text-sm text-gray-700">
                        {index + 1}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <div className="w-16 h-8 overflow-hidden rounded-lg">
                          <img
                            className="w-full h-full object-contain"
                            src={item.hotelLogo}
                            alt=""
                          />
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.hotelName}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <div className="w-20 h-8 overflow-hidden rounded-lg">
                          <img
                            className="w-full h-full object-cover"
                            src={item.imageLink}
                            alt=""
                          />
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {item.roomName}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {item.roomType}
                      </td>

                      <td className="px-4 py-3 text-sm text-gray-700">
                        {item.actualPrice}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {item.discount}(%)
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {item.actualPrice -
                          (item.actualPrice * item.discount) / 100}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.createdAt.slice(0, 10)}
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <div className="flex gap-x-2">
                          <DuplicateButton onClick={() => handleDup(item)} />
                          <EditButton
                            onClick={() =>
                              navigate(`/admin/room/edit/${item.roomId}`)
                            }
                          />
                          <DeleteButton onClick={() => handleDelete(item)} />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <TableLoader colSpan={12} />
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center">
        <p className="text-xs">
          Showing {RoomData.length} of {PageData} entries
        </p>
        <Pagination
          count={PageData || 1}
          page={Page}
          onChange={(event, value) => setPage(value)}
        />
      </div>
    </div>
  );
};

export default RoomList;
